import { render, staticRenderFns } from "./JBZ.vue?vue&type=template&id=462fe560&scoped=true"
import script from "./JBZ.vue?vue&type=script&lang=js"
export * from "./JBZ.vue?vue&type=script&lang=js"
import style0 from "./JBZ.vue?vue&type=style&index=0&id=462fe560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462fe560",
  null
  
)

export default component.exports